"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultWeeklyDayPickerNavigationIcons = exports.defaultWeeklyDayPickerStrings = void 0;
var tslib_1 = require("tslib");
var date_time_utilities_1 = require("@fluentui/date-time-utilities");
exports.defaultWeeklyDayPickerStrings = tslib_1.__assign(tslib_1.__assign({}, date_time_utilities_1.DEFAULT_CALENDAR_STRINGS), { prevWeekAriaLabel: 'Previous week', nextWeekAriaLabel: 'Next week', prevMonthAriaLabel: 'Go to previous month', nextMonthAriaLabel: 'Go to next month', prevYearAriaLabel: 'Go to previous year', nextYearAriaLabel: 'Go to next year', closeButtonAriaLabel: 'Close date picker' });
exports.defaultWeeklyDayPickerNavigationIcons = {
    leftNavigation: 'ChevronLeft',
    rightNavigation: 'ChevronRight',
};
//# sourceMappingURL=defaults.js.map